import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flatlay%20of%20diverse%20fashion%20products%20sneakers%20handbags%20caps%20sunglasses%20and%20accessories%20in%20warm%20terracotta%20peach%20cream%20and%20sage%20green%20tones%20arranged%20organically%20on%20light%20textured%20surface%20with%20soft%20natural%20daylight%20modern%20boutique%20aesthetic%20lifestyle%20composition%20no%20logos%20no%20text%20no%20people&width=1800&height=1000&seq=hero-bg-v2-fresh-01&orientation=landscape"
        alt="PandabuySpreadsheet fashion collection"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight text-balance">
            PandabuySpreadsheet
            <br />
            <span className="text-primary-300">The Ultimate Updated Shopping</span>
            <br />
            <span className="text-white/90">Spreadsheet for 2026</span>
          </h1>
          <p className="mt-5 text-sm md:text-base text-white/70 max-w-xl leading-relaxed">
            Discover the most accurate, curated and updated pandabuy spreadsheet for clothing, shoes, accessories and viral TikTok finds — updated daily with community-verified links.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Pandabuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/25 font-semibold text-sm hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}